import React from 'react';
import styles from '../../css/studyIndexCSS.less';
import { CertificationType } from '@/types/camp/study/contentTypes';
import { Form, Radio, Button } from 'antd';
import successSvg from '@/static/images/success.svg';
import warningSvg from '@/static/images/warning.svg';

interface props {
  data: CertificationType;
  form: any;
}

const Cert: React.FC<props> = ({ data, form }) => {
  // 获取初始数据
  const initialData = {
    [`cret_${data.certification.certId}`]: data.certification.existCertification,
  };

  // 在组件加载时设置表单的初始值
  React.useEffect(() => {
    if (data.certification.existCertification === true) {
      form.setFieldsValue(initialData);
    }
  }, [form, initialData]);

  return (
    <div>
      <div className={styles.new_form_item} id={`cret_${data.certification.certId}_title`}>
        <Form.Item
          style={{ padding: 0 }}
          key={`cret_${data.certification.certId}`}
          name={`cret_${data.certification.certId}`}
          rules={[{ required: true }]}
        >
          <Radio.Group style={{ display: 'none' }}>
            <Radio value={true}>正确</Radio>
          </Radio.Group>
          {data.certification.existCertification === true ? (
            <div className="flex_1">
              <div>
                <img src={successSvg} width={152} height={152} />
              </div>
              <div style={{ marginLeft: 20 }}>
                <div className="f18 fw600">您已通过 {data.certification.certName} 认证</div>
                <div className="f14 col808" style={{ margin: '4px 0 16px' }}>
                  恭喜您通过认证考试，此部分已经完成，如需查询考试成绩&下载证书请点击下方按钮
                </div>
                <Button
                  type="default"
                  href={`${process.env.CERT_URL}verify`}
                  style={{ width: 120, height: 36 }}
                  target="_blank"
                >
                  证书&成绩查询
                </Button>
              </div>
            </div>
          ) : (
            <div className="flex_1">
              <div>
                <img src={warningSvg} width={152} height={152} />
              </div>
              <div style={{ marginLeft: 20 }}>
                <div className="f18 fw600">需要通过 {data.certification.certName} 认证</div>
                <div className="f14 col808" style={{ margin: '4px 0 16px' }}>
                  在线考试形式，未通过前可重复参与
                </div>
                <Button
                  type="primary"
                  href={`${process.env.CERT_URL}detail/${data.certification.certId}`}
                  style={{ width: 120, height: 36 }}
                  target="_blank"
                >
                  前往认证
                </Button>
              </div>
            </div>
          )}
        </Form.Item>
      </div>
    </div>
  );
};
export default Cert;
